/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  Container,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
  Button,
} from "@common-ui/ui";
import JsPDF from "jspdf";
import { WorkItem } from "../../../components/CollapsibleData/WorkItem";

import { getWorkItem, getWorkItems } from "../../../services/WorkItems";
import {
  getAssetDetails,
  getCustomer,
  getOrgWorkEvent,
  getProcedure,
} from "../../../services";
import { getProcedureStatus } from "../../../services/procedureRuntime";
import { useDispatch } from "react-redux";
import { workItemsSlice } from "../../../reducers/workItemsReducer";
import { getOrg, getOrgProfileImage } from "../../../services/org";
import SummaryDownload from "../../../components/SummaryDownload";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
// import { orderBy } from "lodash";
// import Html2Pdf from "html2pdf.js";

const SummaryReport = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [workItem, setWorkItem] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [workEvent, setWorkEvent] = useState(null);
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState([]);
  const [asset, setAsset] = useState(null);
  const [performingOrg, setPerformingOrg] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [orgImageFileType, setOrgImageFileType] = useState("");
  const workItems = useSelector((state) => state.workItems);
  const reportRef = React.useRef(null);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    onPrintError: (error) => console.log(error),
    content: () => componentRef.current,
  });

  let { workEventId, performing_org } = useParams();
  async function init() {
    try {
      let workEvent = await getOrgWorkEvent(performing_org, workEventId);
      workEvent = workEvent?.data;
      console.log("workEvent", workEvent);
      const workItems = await getWorkItems(workEventId, performing_org);
      console.log("workItems", workItems);

      workItems.forEach(async (workItem) => {
        if (workItem) {
          console.log("workItem", workItem);
          const asset = await getAssetDetails(
            workItem.performing_org,
            workItem.asset?.system_id
          );
          const performingOrg = await getOrg(workItem.performing_org);

          let { logo } = performingOrg;

          if (logo && logo.length) {
            const imageType = logo
              .split("?")[0]
              .split("/")
              .slice(-1)[0]
              .split(".")[1];
            setOrgImageFileType(imageType);
          }
          try {
            if (!workEvent?.data?.for_customer) {
              const internalCUstomer = await getOrg(workEvent?.data?.for_org);
              setCustomer(internalCUstomer);
            } else {
              const externalCUstomer = await getOrgCustomer(
                params?.orgId,
                workEvent?.data?.for_customer
              );
              setCustomer(externalCUstomer);
            }
            console.log("customer", customer);
          } catch (error) {}

          setWorkEvent(workEvent?.data);

          setWorkEvent(workEvent);

          setPerformingOrg(performingOrg);
          setWorkItem(workItem);
          setAsset(asset);
          let procedure = await getProcedure(
            workItem?.service_option_procedure,
            workItem?.performing_org,
            workItem.service_type,
            workItem.service_option
          );
          let procedureStatus = await getProcedureStatus(
            workItem?.performing_org,
            workItem?.work_event,
            workItem.id
          );
          const row = {
            ...workItem,
            defaultProcedure: procedure,
            procedure: { ...procedure, status: procedureStatus },
          };
          dispatch(workItemsSlice.actions.setWorkItem(row));
          // setRow(row);

          setIsLoading(false);
        }
      });
    } catch (e) {
      setErrors([...errors, e]);
      setIsLoading(false);
      console.log(e);
    }
  }

  //console.log(id)
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    async function getImage() {
      try {
        if (workItem) {
          const response = await getOrgProfileImage(
            workItem?.performing_org,
            orgImageFileType
          );
          setImageUrl(response.data.url);
        }
      } catch (error) {
        setImageUrl("");
        console.log(error);
      }
    }
    if (orgImageFileType?.length) getImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgImageFileType, JSON.stringify(workItem?.performing_org)]);

  return isLoading ? (
    "Loading..."
  ) : (
    <div
      id="report"
      // ref={reportRef}
    >
      <Container>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            // onClick={generatePDF}
            // onClick={handlePrint}
            onClick={() => {
              setTimeout(() => handlePrint.onBeforePrint(), 10000);

              window.print();
            }}
            type="button"
          >
            Export PDF
          </Button>
        </Box>
      </Container>
      <Container ref={componentRef} sx={{ width: "100%" }}>
        <Box>
          <SummaryDownload
            orgId={performingOrg?.id}
            eventId={workEventId}
            combined={true}
          />
        </Box>
        <Box>
          {Object.keys(workItems)
            ?.sort()
            ?.map((key) => {
              return (
                <div key={key}>
                  <Typography sx={{ my: 2 }} variant="h6">
                    WorkItem # {key}
                  </Typography>
                  <WorkItem
                    row={workItems[key]}
                    orgID={workItems[key].performing_org}
                    mode="REPORT_VIEW"
                    report
                  />
                </div>
              );
            })}
        </Box>
      </Container>
    </div>
  );
};

export { SummaryReport };
